import { StoryKey } from "@/api/event/commonStoreKey";
import { FORMAT_REG } from "@/Core/features/verification";
import { useStore } from "react-hook-simple-state";
import { getCurrentLoginConfig } from "@/utils/countryConfigUtils";
import { hasPhoneFormatError, isPhoneInputValid } from "./phoneValidation";

export { hasPhoneFormatError, isPhoneInputValid } from "./phoneValidation";

export const isPhoneLikeLoginInput = (input = "") => {
  const digitCount = input.replace(/\D/g, "").length;

  return digitCount >= 3 && /^[\d\s]+$/.test(input);
};

/**
 * 验证输入手机号并返回错误（配置驱动）
 */
export const validatorPhone = (v, t) => {
  if (!v || !v?.select || !v?.input) {
    return t("Phone-3");
  }

  // 从配置中获取手机号验证规则
  const loginConfig = getCurrentLoginConfig();
  const phoneRules = loginConfig?.phone || { min: 8, max: 10 };

  if (!isPhoneInputValid(v.input, phoneRules)) {
    return t("Phone-3");
  }
};

/**
 * 验证图smsCode并 返回错误提示
 */
export const validatorSmsCode = (v, t) => {
  const flag = new RegExp(FORMAT_REG.SMS_CODE).test(v);
  if (!flag || !v) {
    return t("SmsCode-2");
  }
};

/**
 * 验证邮箱
 */
export const validatorEmail = (v, t) => {
  const flag = new RegExp(FORMAT_REG.EMAIL).test(v);
  if (!flag || !v) {
    return t("Email-2");
  }
};
/**
 * 验证密码并返回错误
 */
export const validatorPassword = (value, t) => {
  const flag = new RegExp(FORMAT_REG.PASSWORD).test(value);
  if (!flag || !value) {
    return t("Account-3");
  }
};

/**
 * 验证账号并返回错误
 */
export const validatorAccount = (value, t) => {
  const flag = new RegExp(FORMAT_REG.LOGIN_USERNAME).test(value);
  if (!flag || !value) {
    return t("Account-3");
  }
};

/** Auth popup mode: 1 login, 2 register, 3 forgot password, 4 forgot email password. */
export const useAuthPopupMode = () => {
  return useStore<number>(StoryKey.GlobalChangeLoginRegister, 1);
};

export const validatorAccountPlus = (value, t) => {
  if (!value) {
    return t("InputEmpty");
  }
};

export const useGlobalOpenRegisterLoading = () => {
  return useStore<boolean>(StoryKey.GlobalOpenRegisterLoading, false);
};
